import { createSlice } from '@reduxjs/toolkit';
import { logout, postLogin, switchOrganization } from '../auth/auth.action';
import { deleteOrganizationDetails, patchOrganizationDetails } from '../organizations/organizations.action';
import {
  deleteUserAccessDetails,
  patchUserDetails,
  postSwitchUserOrganization,
  postUserAccess,
  setUserOrgRole,
} from '../users/users.action';
import { fetchGlobalScopes, fetchOrgScopes } from './authorization.action';

type AuthorizationState = {
  globalScopes: Record<string, true> | null;
  globalScopesRequested: boolean;

  orgScopes: Record<number, Record<string, true>>;
  orgScopesRequested: Record<number, true>;
};

const INIT_STATE: AuthorizationState = {
  globalScopes: null,
  globalScopesRequested: false,

  orgScopes: {},
  orgScopesRequested: {},
};

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState: INIT_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGlobalScopes.pending, state => {
        state.globalScopesRequested = true;
      })
      .addCase(fetchGlobalScopes.fulfilled, (state, action) => {
        state.globalScopes = Object.fromEntries(action.payload.map(scope => [scope, true]));
      });

    builder
      .addCase(fetchOrgScopes.pending, (state, action) => {
        state.orgScopesRequested[action.meta.arg.orgId] = true;
      })
      .addCase(fetchOrgScopes.fulfilled, (state, action) => {
        state.orgScopes[action.meta.arg.orgId] = Object.fromEntries(action.payload.map(scope => [scope, true]));
      });

    // Soft invalidates
    [
      switchOrganization,
      patchOrganizationDetails,
      deleteOrganizationDetails,
      patchUserDetails,
      postUserAccess,
      postSwitchUserOrganization,
      deleteUserAccessDetails,
      setUserOrgRole,
    ].forEach(a =>
      builder.addCase(a.fulfilled, state => {
        state.globalScopesRequested = false;
        state.orgScopesRequested = {};
      })
    );

    // Hard resets
    [postLogin, logout].forEach(a =>
      builder.addCase(a.fulfilled, state => {
        state.globalScopes = null;
        state.globalScopesRequested = false;
        state.orgScopes = {};
        state.orgScopesRequested = {};
      })
    );
  },
});

export default authorizationSlice.reducer;
